import { USAGE_TYPE, type MaterialUsageType } from '@/lib/api/material-process';

/**
 * 素材域里前端要判的权限码，与后端 MaterialPermissionCodes 同名。
 *
 * 只收界面上真正用来控制入口的那几个 edit 码。read 和 all 全在服务端判——
 * 前端拿不到 usageType 之外的上下文，照着抄一份只会有两份会分叉的真相。
 *
 * 收进常量是因为 review / display 按 usageType 成对出现，写字面量必然会有人挑错那一半。
 */
export const MATERIAL_PERM = {
  reviewEdit: 'api:ads-admin:material:review:edit',
  displayEdit: 'api:ads-admin:material:display:edit',
  processEdit: 'api:ads-admin:material:process:edit',
} as const;

/** 上传这一类素材需要的码。两个素材库页只差一个 usageType，别在页面里写 if。 */
export function uploadPermOf(usageType: MaterialUsageType): string {
  return usageType === USAGE_TYPE.REVIEW ? MATERIAL_PERM.reviewEdit : MATERIAL_PERM.displayEdit;
}
